import ChapterSearchBar from 'layout/ApplicationLayout/components/ChapterSearchBar/ChapterSearchBar';

export default ChapterSearchBar;
